/**
 * Preserves collection filters and sorting while navigating directly to a page.
 */
document.addEventListener('input', (event) => {
  const input = event.target;
  if (input instanceof HTMLInputElement && input.closest('[data-pagination-jump-form]')) {
    input.setCustomValidity('');
  }
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-pagination-jump-form]')) return;

  event.preventDefault();

  const input = form.elements.namedItem('page');
  if (!(input instanceof HTMLInputElement)) return;

  const page = Number.parseInt(input.value, 10);
  const minimum = Number.parseInt(input.min, 10);
  const maximum = Number.parseInt(input.max, 10);

  if (!Number.isInteger(page) || page < minimum || page > maximum) {
    input.setCustomValidity(`Enter a page from ${minimum} to ${maximum}.`);
    input.reportValidity();
    return;
  }

  input.setCustomValidity('');
  const url = new URL(window.location.href);
  url.searchParams.set('page', String(page));
  window.location.assign(url.toString());
});
